/**
 * StoriesProgressBar — Tracinhos de progresso estilo Instagram Stories.
 *
 * • Itens anteriores ao current: preenchimento 100% (branco sólido)
 * • Item atual: preenchimento proporcional ao progress (0→1) via largura inline
 *   — sem CSS transition para evitar lag visual entre frames do rAF
 * • Itens futuros: 0% (trilho translúcido visível, fundo bg-white/25)
 */

interface Props {
  total:      number;
  currentIdx: number;
  /** Progresso do item atual: 0.0 a 1.0 */
  progress:   number;
}

export default function StoriesProgressBar({ total, currentIdx, progress }: Props) {
  return (
    <div className="absolute top-0 left-0 right-0 z-10 flex gap-1 p-2">
      {Array.from({ length: total }, (_, i) => (
        <div key={i} className="flex-1 h-[3px] rounded-full bg-white/25 overflow-hidden">
          <div
            className="h-full bg-white rounded-full relative overflow-hidden"
            style={{
              width:      i < currentIdx ? '100%' : i === currentIdx ? `${progress * 100}%` : '0%',
              transition: i === currentIdx ? 'none' : undefined,
            }}
          >
            {i === currentIdx && (
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent animate-stories-shine" />
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
